/* Minimal hash router: #/<trackId>/<levelId>. Hash URLs work on static hosting without rewrites. */
import { useSyncExternalStore } from "react";

export function parseHash(hash) {
  const [trackId = null, levelId = null] = hash.replace(/^#\/?/, "").split("/").filter(Boolean).map(decodeURIComponent);
  return { trackId, levelId };
}

export function hrefFor(trackId, levelId) {
  if (!trackId) return "#/";
  return levelId ? `#/${encodeURIComponent(trackId)}/${encodeURIComponent(levelId)}` : `#/${encodeURIComponent(trackId)}`;
}

export function navigate(trackId, levelId) {
  window.location.hash = hrefFor(trackId, levelId);
}

function subscribe(listener) {
  window.addEventListener("hashchange", listener);
  return () => window.removeEventListener("hashchange", listener);
}

const getHash = () => window.location.hash;

export function useRoute() {
  const hash = useSyncExternalStore(subscribe, getHash, () => "");
  return parseHash(hash);
}
